import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({fileUrl, printRef, isLayer=false}) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
      setNumPages(numPages);
    }
  
    return (
        <div>
            <div style={{width:'100%', height:"100%", overflow: 'auto'}} ref={printRef}>
                <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess} >
                    {isLayer ? 
                    <Page width={900} pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
                    :
                    <Page width={710} pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
                    }
                </Document>
            </div>
            <div>
                <div style={{textAlign:"center", color:"#000"}}>
                  <ArrowBackIosIcon style={{cursor:"pointer", marginRight:"10px"}} onClick={() => {
                      setPageNumber(pageNumber === 1 ? pageNumber : pageNumber - 1)
                  }}/>

                  Page {pageNumber} of {numPages}
                  
                  <ArrowForwardIosIcon style={{cursor:"pointer", marginLeft:"10px"}} onClick={() => {
                      setPageNumber(numPages === pageNumber ? pageNumber : pageNumber + 1)
                  }}/>
                </div>
            </div>
        </div>
    );
}

export default PdfViewer;